import React, { useRef } from "react";
import Header from "../common/Header";
import { Button, List, Toolbar } from "devextreme-react";
import { releases } from "./data";
import ReleaseItem from "./ReleaseItem";

import "./index.css";
import { Item } from "devextreme-react/toolbar";
import { useNavigate } from "react-router";

export default function ReleaseNotes() {
  const releaseNotesList = useRef(null);

  const navigate = useNavigate();

  const groupRender = (item) => {
    return (
      <h2>
        {item.date} (Release {item.key})
      </h2>
    );
  };

  const onClick = (e) => {
    navigate("/qna");
  };

  return (
    <React.Fragment>
      <Header title={"BeTree Release Notes"} menuDataSource={null} />

      <div className="devsite-content">
        <Toolbar>
          <Item location={"after"}>
            <Button
              text="Send Feedback"
              type="default"
              stylingMode="outlined"
              style={{
                display: "block",
              }}
              onClick={onClick}
            />
          </Item>
        </Toolbar>
        <List
          ref={releaseNotesList}
          dataSource={releases}
          height={"100%"}
          grouped={true}
          collapsibleGroups={true}
          groupRender={groupRender}
          itemRender={ReleaseItem}
          className="devsite-article"
        />
      </div>
    </React.Fragment>
  );
}
